(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerMainShell = this.querySelector('.header-main-shell');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.scrollDirectionThreshold = 4;
      this.compactAfterScrollDistance = 56;
      this.lastExpandedScrollTop = this.currentScrollTop;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.expandHeaderOnIntent = this.expandOnIntent.bind(this);
      this.expandHeaderOnMenuToggle = this.expandOnMenuToggle.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.addEventListener('pointerenter', this.expandHeaderOnIntent);
      this.header.addEventListener('focusin', this.expandHeaderOnIntent);
      this.header.addEventListener('toggle', this.expandHeaderOnMenuToggle, true);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      if (this.headerMainShell) {
        document.documentElement.style.setProperty('--header-main-height', `${this.headerMainShell.offsetHeight}px`);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      this.header.removeEventListener('pointerenter', this.expandHeaderOnIntent);
      this.header.removeEventListener('focusin', this.expandHeaderOnIntent);
      this.header.removeEventListener('toggle', this.expandHeaderOnMenuToggle, true);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.headerIsAlwaysSticky && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (scrollDelta < -this.scrollDirectionThreshold) {
          this.expand(scrollTop);
        } else if (
          scrollDelta > this.scrollDirectionThreshold &&
          scrollTop - this.lastExpandedScrollTop >= this.compactAfterScrollDistance
        ) {
          this.compact();
        }

        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.header.classList.remove('section-header--compact');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.header.classList.remove('section-header--compact');
    }

    reset() {
      this.header.classList.remove('section-header--compact');
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    compact() {
      if (this.header.classList.contains('section-header--compact')) return;
      this.header.classList.add('section-header--compact');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    expand(scrollTop = window.pageYOffset || document.documentElement.scrollTop) {
      if (!this.header.classList.contains('section-header--compact')) return;
      this.header.classList.remove('section-header--compact');
      this.lastExpandedScrollTop = scrollTop;
    }

    expandOnIntent() {
      if (this.headerIsAlwaysSticky) this.expand();
    }

    expandOnMenuToggle(event) {
      if (event.target.open && this.headerIsAlwaysSticky) this.expand();
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["savalion-media-hero"] && !Shopify.designMode) return;
  try {
    
  class SavalionLazyVideo extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      if (!this.template) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting) continue;
            this.#load();
            this.observer.disconnect();
            break;
          }
        },
        { rootMargin: '200px 0px' }
      );

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    #load() {
      if (this.loaded) return;
      this.loaded = true;

      this.appendChild(this.template.content.cloneNode(true));
      this.classList.add('is-loaded');

      // FIX: Sanftes Ausblenden statt hartem remove()
      const poster = this.querySelector('.savalion-lazy-video__poster');
      if (poster) {
        poster.style.transition = 'opacity 0.4s ease';
        poster.style.opacity = '0';
        poster.addEventListener('transitionend', () => poster.remove(), { once: true });
      }

      this.querySelector('video')?.play?.().catch(() => {});
    }
  }

  if (!customElements.get('savalion-lazy-video')) {
    customElements.define('savalion-lazy-video', SavalionLazyVideo);
  }

  } catch(e) { console.error(e); }
})();
})();
